import oktaSignIn from 'okta';

const { authClient } = oktaSignIn;

const { tokenManager } = authClient;

export const getAccessToken = async () => {
  try {
    const accessTokenData = await tokenManager.get('accessToken');

    if (!accessTokenData) {
      return null;
    }

    return accessTokenData.accessToken;
  } catch (err) {
    return null;
  }
};
